import Dexie from 'dexie'

export class CommerceDatabase extends Dexie {
  constructor() {
    super('CommerceAppDB')

    // Version 1 - schéma original
    this.version(1).stores({
      products: '++id, &code, name, createdAt, basePrice',
      purchases: '++id, clientName, date, totalAmount, clientPhone',
      metadata: '&key',
      shopInfo: '&id',
    })

    // Version 2 - ajout des UUIDs et timestamps
    this.version(2)
      .stores({
        products: '++id, uuid, &code, name, createdAt, updatedAt, basePrice',
        purchases:
          '++id, uuid, clientName, date, totalAmount, clientPhone, createdAt, updatedAt',
        metadata: '&key',
        shopInfo: '&id',
      })
      .upgrade(async (tx) => {
        const generateUUID = () => {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
            /[xy]/g,
            function (c) {
              const r = (Math.random() * 16) | 0
              const v = c === 'x' ? r : (r & 0x3) | 0x8
              return v.toString(16)
            },
          )
        }

        const now = new Date().toISOString()

        await tx
          .table('products')
          .toCollection()
          .modify((product) => {
            if (!product.uuid) product.uuid = generateUUID()
            if (!product.createdAt) product.createdAt = now
            if (!product.updatedAt) product.updatedAt = now
          })

        await tx
          .table('purchases')
          .toCollection()
          .modify((purchase) => {
            if (!purchase.uuid) purchase.uuid = generateUUID()
            if (!purchase.createdAt) purchase.createdAt = now
            if (!purchase.updatedAt) purchase.updatedAt = now
          })
      })

    // Version 3 - ajout de shopId pour isolation des données par boutique
    this.version(3).stores({
      products:
        '++id, uuid, shopId, &code, name, createdAt, updatedAt, basePrice, [shopId+code]',
      purchases:
        '++id, uuid, shopId, clientName, date, totalAmount, clientPhone, createdAt, updatedAt',
      metadata: '&key',
      shopInfo: '&id',
    })

    // Version 4 : Gestion gérant
    this.version(4)
      .stores({
        products:
          '++id, uuid, shopId, &code, name, createdAt, updatedAt, basePrice, [shopId+code], managerId',
        purchases:
          '++id, uuid, shopId, clientName, date, totalAmount, clientPhone, createdAt, updatedAt, managerId',
        metadata: '&key',
        shopInfo: '&id',
        managers: '++id, _id, shopId, phone, name, role, isActive',
      })
      .upgrade(async (tx) => {
        // Migration pour ajouter managerId aux produits et achats existants
        await tx
          .table('products')
          .toCollection()
          .modify((product) => {
            if (!product.managerId) product.managerId = null
          })

        await tx
          .table('purchases')
          .toCollection()
          .modify((purchase) => {
            if (!purchase.managerId) purchase.managerId = null
          })
      })

    // Version 5 - CORRECTION : Retrait de &code global pour permettre le même code dans différentes boutiques
    this.version(5).stores({
      products:
        '++id, uuid, shopId, name, createdAt, updatedAt, basePrice, [shopId+code], managerId',
      purchases:
        '++id, uuid, shopId, clientName, date, totalAmount, clientPhone, createdAt, updatedAt, managerId',
      metadata: '&key',
      shopInfo: '&id',
      managers: '++id, _id, shopId, phone, name, role, isActive',
    })
  }
}

export const db = new CommerceDatabase()
